import React, { useCallback, useEffect, useState } from 'react';
import eventBus from '../EventBus';
const LoadingScreen = () => {
    const [progress, setProgress] = useState(0);
    const [toLoad, setToLoad] = useState(0);
    const [loaded, setLoaded] = useState(0);
    const [overlayOpacity, setLoadingOverlayOpacity] = useState(1);
    const [loadingTextOpacity, setLoadingTextOpacity] = useState(1);
    const [startPopupOpacity, setStartPopupOpacity] = useState(0);
    const [firefoxPopupOpacity, setFirefoxPopupOpacity] = useState(0);
    const [webGLErrorOpacity, setWebGLErrorOpacity] = useState(0);
    const [showBiosInfo, setShowBiosInfo] = useState(false);
    const [showLoadingResources, setShowLoadingResources] = useState(false);
    const [doneLoading, setDoneLoading] = useState(false);
    const [webGLError, setWebGLError] = useState(false);
    const [counter, setCounter] = useState(0);
    const [resources] = useState([]);
    const [mobileWarning, setMobileWarning] = useState(window.innerWidth < 768);
    const onResize = () => {
        if (window.innerWidth < 768) {
            setMobileWarning(true);
        }
        else {
            setMobileWarning(false);
        }
    };
    window.addEventListener('resize', onResize);
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('debug')) {
            start();
        }
        else if (!detectWebGLContext()) {
            setWebGLError(true);
        }
        else {
            setShowBiosInfo(true);
        }
    }, []);
    useEffect(() => {
        eventBus.on('loadedSource', (data) => {
            setProgress(data.progress);
            setToLoad(data.toLoad);
            setLoaded(data.loaded);
            resources.push(`Loaded ${data.sourceName}${getSpace(data.sourceName)} ... ${Math.round(data.progress * 100)}%`);
            if (resources.length > 8) {
                resources.shift();
            }
        });
    }, []);
    useEffect(() => {
        setShowLoadingResources(true);
        setCounter(counter + 1);
    }, [loaded]);
    useEffect(() => {
        if (progress >= 1 && !webGLError) {
            setDoneLoading(true);
            setTimeout(() => {
                setLoadingTextOpacity(0);
                setTimeout(() => {
                    setStartPopupOpacity(1);
                }, 500);
            }, 1000);
        }
    }, [progress]);
    useEffect(() => {
        if (webGLError) {
            setTimeout(() => {
                setWebGLErrorOpacity(1);
            }, 500);
        }
    }, [webGLError]);
    const start = useCallback(() => {
        setLoadingOverlayOpacity(0);
        eventBus.dispatch('loadingScreenDone', {});
        const ui = document.getElementById('ui');
        if (ui) {
            ui.style.pointerEvents = 'none';
        }
    }, []);
    const getSpace = (sourceName) => {
        let spaces = '';
        for (let i = 0; i < 24 - sourceName.length; i++)
            spaces += '\xa0';
        return spaces;
    };
    const getCurrentDate = () => {
        const date = new Date();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const year = date.getFullYear();
        // add leading zero
        const monthFormatted = month < 10 ? `0${month}` : month;
        const dayFormatted = day < 10 ? `0${day}` : day;
        return `${monthFormatted}/${dayFormatted}/${year}`;
    };
    const detectWebGLContext = () => {
        var canvas = document.createElement('canvas');
        // Get WebGLRenderingContext from canvas element.
        var gl = canvas.getContext('webgl') ||
            canvas.getContext('experimental-webgl');
        // Report the result.
        if (gl && gl instanceof WebGLRenderingContext) {
            return true;
        }
        return false;
    };
    return (React.createElement("div", { style: Object.assign({}, styles.overlay, {
            opacity: overlayOpacity,
            transform: `scale(${overlayOpacity === 0 ? 1.1 : 1})`,
        }) },
        startPopupOpacity === 0 && loadingTextOpacity === 0 && (React.createElement("div", { style: styles.blinkingContainer },
            React.createElement("span", { className: "blinking-cursor" }))),
        !webGLError && (React.createElement("div", { style: Object.assign({}, styles.overlayText, {
                opacity: loadingTextOpacity,
            }) },
            React.createElement("div", { style: styles.header, className: "loading-screen-header" },
                React.createElement("div", { style: styles.logoContainer },
                    React.createElement("div", null,
                        React.createElement("p", { style: styles.green },
                            React.createElement("b", null, "Gollu,"),
                            ' '),
                        React.createElement("p", { style: styles.green },
                            React.createElement("b", null, "Sai Dheeraj Inc.")))),
                React.createElement("div", { style: styles.headerInfo },
                    React.createElement("p", null, "Released: 01/13/2000"),
                    React.createElement("p", null, "SDBIOS (C)2000 Gollu Sai Dheeraj Inc.,"))),
            React.createElement("div", { style: styles.body, className: "loading-screen-body" },
                React.createElement("p", null, "HSP S13 2000-2022 Special UC131S"),
                React.createElement("div", { style: styles.spacer }),
                showBiosInfo && (React.createElement(React.Fragment, null,
                    React.createElement("p", null, "HSP Showcase(tm) XX 113"),
                    React.createElement("p", null,
                        "Checking RAM : ",
                        14000,
                        " OK"),
                    React.createElement("div", { style: styles.spacer }),
                    React.createElement("div", { style: styles.spacer }),
                    showLoadingResources ? (progress == 1 ? (React.createElement("p", null, "FINISHED LOADING RESOURCES")) : (React.createElement("p", { className: "loading" },
                        "LOADING RESOURCES (",
                        loaded,
                        "/",
                        toLoad === 0 ? '-' : toLoad,
                        ")"))) : (React.createElement("p", { className: "loading" }, "WAIT")))),
                React.createElement("div", { style: styles.spacer }),
                React.createElement("div", { style: styles.resourcesLoadingList }, resources.map((sourceName) => (React.createElement("p", { key: sourceName }, sourceName)))),
                React.createElement("div", { style: styles.spacer }),
                showLoadingResources && doneLoading && (React.createElement("p", null,
                    "All Content Loaded, launching",
                    ' ',
                    React.createElement("b", { style: styles.green }, "'Sai Dheeraj Gollu Portfolio Showcase'"),
                    ' ',
                    "V1.0")),
                React.createElement("div", { style: styles.spacer }),
                React.createElement("span", { className: "blinking-cursor" })),
            React.createElement("div", { style: styles.footer, className: "loading-screen-footer" },
                React.createElement("p", null,
                    "Press ",
                    React.createElement("b", null, "DEL"),
                    " to enter SETUP , ",
                    React.createElement("b", null, "ESC"),
                    " to skip memory test"),
                React.createElement("p", null, getCurrentDate())))),
        React.createElement("div", { style: Object.assign({}, styles.popupContainer, {
                opacity: startPopupOpacity,
            }) },
            React.createElement("div", { style: styles.startPopup },
                React.createElement("p", null, "Sai Dheeraj Gollu Portfolio Showcase 2024"),
                mobileWarning && (React.createElement(React.Fragment, null,
                    React.createElement("br", null),
                    React.createElement("b", null,
                        React.createElement("p", { style: styles.warning }, "WARNING: This experience is best viewed on"),
                        React.createElement("p", { style: styles.warning }, "a desktop or laptop computer.")),
                    React.createElement("br", null))),
                React.createElement("div", { style: { display: 'flex', alignItems: 'flex-end' } },
                    React.createElement("p", null,
                        "Click start to begin",
                        '\xa0'),
                    React.createElement("span", { className: "blinking-cursor" })),
                React.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '16px',
                    } },
                    React.createElement("div", { className: "bios-start-button", onClick: start },
                        React.createElement("p", null, "START"))))),
        webGLError && (React.createElement("div", { style: Object.assign({}, styles.popupContainer, {
                opacity: webGLErrorOpacity,
            }) },
            React.createElement("div", { style: styles.startPopup },
                React.createElement("p", null,
                    React.createElement("b", { style: { color: 'red' } }, "CRITICAL ERROR:"),
                    " No WebGL Detected"),
                React.createElement("div", { style: styles.spacer }),
                React.createElement("div", { style: styles.spacer }),
                React.createElement("p", null, "WebGL is required to run this site."),
                React.createElement("p", null, "Please enable it or switch to a browser which supports WebGL"))))));
};
const styles = {
    overlay: {
        backgroundColor: 'black',
        width: '100%',
        height: '100%',
        display: 'flex',
        transition: 'opacity 0.2s, transform 0.2s',
        MozTransition: 'opacity 0.2s, transform 0.2s',
        WebkitTransition: 'opacity 0.2s, transform 0.2s',
        OTransition: 'opacity 0.2s, transform 0.2s',
        msTransition: 'opacity 0.2s, transform 0.2s',
        transitionTimingFunction: 'ease-in-out',
        MozTransitionTimingFunction: 'ease-in-out',
        WebkitTransitionTimingFunction: 'ease-in-out',
        OTransitionTimingFunction: 'ease-in-out',
        msTransitionTimingFunction: 'ease-in-out',
        boxSizing: 'border-box',
        fontSize: 16,
        letterSpacing: 0.8,
    },
    spacer: {
        height: 16,
    },
    header: {
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'row',
    },
    popupContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    warning: {
        color: 'yellow',
    },
    blinkingContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        boxSizing: 'border-box',
        padding: 48,
    },
    startPopup: {
        backgroundColor: '#000',
        padding: 24,
        border: '7px solid #fff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        maxWidth: 500,
        // alignItems: 'center',
    },
    headerInfo: {
        marginLeft: 64,
    },
    red: {
        color: '#00ff00',
    },
    link: {
        // textDecoration: 'none',
        color: '#4598ff',
        cursor: 'pointer',
    },
    overlayText: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    body: {
        flex: 1,
        display: 'flex',
        width: '100%',
        boxSizing: 'border-box',
        flexDirection: 'column',
    },
    logoContainer: {
        display: 'flex',
        flexDirection: 'row',
    },
    resourcesLoadingList: {
        display: 'flex',
        paddingLeft: 32,
        paddingBottom: 32,
        flexDirection: 'column',
    },
    logoImage: {
        width: 64,
        height: 42,
        imageRendering: 'pixelated',
        marginRight: 16,
    },
    footer: {
        boxSizing: 'border-box',
        width: '100%',
    },
};
export default LoadingScreen;
